<h1 mat-dialog-title>Details id: {{data.id}}</h1>
<div mat-dialog-content>
  <p>{{data.description}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
</div>
